import Router from 'vue-router'
import comum from './routes/routes'
import portal from './routes/routesPortal'

const index = new Router({
    routes: [
        ...comum,
        ...portal
    ]
})

export default index
